import { render } from "./TestAttachments.vue?vue&type=template&id=3b1e1e0b"
import script from "./TestAttachments.vue?vue&type=script&lang=js"
export * from "./TestAttachments.vue?vue&type=script&lang=js"

import "./TestAttachments.vue?vue&type=style&index=0&id=3b1e1e0b&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/TestAttachments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b1e1e0b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b1e1e0b', __exports__)) {
    console.log('reload')
    api.reload('3b1e1e0b', __exports__)
  }
  
  module.hot.accept("./TestAttachments.vue?vue&type=template&id=3b1e1e0b", () => {
    console.log('re-render')
    api.rerender('3b1e1e0b', render)
  })

}


export default __exports__